export const faqs = [
  {
    question: 'What is Devsnest?',
    answer:
      'Devsnest is peer-peer learning platform which makes you industry ready Full stack    developer within 7 months.'
  },
  {
    question: 'Who are the mentors?',
    answer:
      'Mentors are Developers from top tech companies like Google, Facebook, Amazon who will be helping students in the community.'
  },
  {
    question: 'How do I apply for this mentorship?',
    answer:
      'Click on the Join Us button at [devsnest.in](https://devsnest.in) or you can alternatively click on this [link](https://devsnest.in).'
  },
  {
    question: 'What is the duration of the mentorship?',
    answer:
      'The ideal duration of the mentorship is 7 months, Some students will be able to get a job sooner and some might need some more revision classes.'
  },
  {
    question: 'What is the fees for this mentorship?',
    answer:
      'The mentorship is free of cost. We require only your eagerness and desire to learn new things.'
  },
  {
    question: 'What are the prerequisites to join this mentorship?',
    answer:
      'Students applying should have a basic understanding of English and Mathematics, and they should go through a week long python primer to check if coding is for them.'
  },
  {
    question: 'Will I get a certificate after the compilation of course?',
    answer:
      'Yes,  you will get a certificate after the completion of the course. Separate certificates are also provided for the different courses such as DSA, Frontend, and Backend.'
  },
  {
    question: 'What is the effort required from a student?',
    answer:
      'Effort required is close to min 4-5 hours in a day in which you have to attend classes, do sessions with peers and do tasks and assignments. Peer learning and collaboration are one of the core values of Devsnest.'
  },
  {
    question: 'How is the learning environment at Devsnest?',
    answer:
      'We are India’s largest peer-peer learning program. When you joined the mentorship you will assign to a group. This group will be based on your interest and your skills. All the group members gathering together and solving question of top companies and creating fun projects. We are also organising different events so that you can do more communication with your group members and other groups as well.'
  },
  {
    question: 'Does the mentorship involve interview preparation as well?',
    answer:
      ' Yes, In our last month we would be focusing on improving your resume and cover letter as well as getting you mock interviews and help you become job ready.'
  },
  {
    question: 'Does Devsnest guarantee me a job?',
    answer:
      'No, Although we focus on teaching on demand industry skills and making you noticeable     by recruiters by getting you referrals and showcasing your project on our website but clearing interviews is the sole responsibility of students. Our product is majorly focused towards upskilling our students, not guaranteeing them a job.'
  },
  {
    question:
      'Does any school, college or cohort matter to be a part of this mentorship?',
    answer:
      'There are no boundations in terms of the degree you are pursuing. This is open for everyone who is curious and willing to put in the required effort.'
  },
  {
    question: 'Does college CGPA play any role in the Program?',
    answer: 'No, we believe in skills rather than results.'
  },
  {
    question: 'I am not currently looking for a job, is the mentorship for me?',
    answer:
      ' Devsnest also provides students with various internships and freelancing opportunities. Multiple mentors in the community will guide students to start collaborating on open source projects after the course.'
  },
  {
    question: 'The class hours don’t work for me, what do i do?',
    answer:
      ' We will record all the classes, but group meetings are mandatory for each student. You have to make sure that you can attend other mandatory meetings and do the assignments on time.'
  },
  {
    question:
      'I work full time but I would like to join the mentorship, what are the options?',
    answer:
      'You are free to join the mentorship even if you are employed full time. We will provide you with the recorded lectures but it will be mandatory for you to complete the given assignments and actively participate in group meetings.'
  },
  {
    question: 'What happens after the mentorship is over?',
    answer: 'You retain lifetime exclusive membership of the community.'
  },
  {
    question: 'Whom to contact in case of any doubt related to the mentorship?',
    answer:
      'You can email us at [support@devsnest.in](mailto:support@devsnest.in) or you can contact a moderator on discord. Also, there is a channel called course-doubts on our Discord server, you can put in your query there.'
  }
]
